<template>
    <div class="container-fluid">
        <div id="div-lead" v-if="this.requestLeadSend == 1">
            <button class="btn" type="button" @click="ShowMoalRequestLead">
                <ficon :icon="['fas', 'headphones']" class="color-icon-conv"></ficon>
            </button>
        </div>
        <div id="index-client">
            <div class="row d-block">
                <div class="col-md-12 col-xs-12 col-sm-12" id="header-client">
                    <div class="row">
                        <div class="col-10 p-3 text-left">
                            Ciao, <strong>{{this.usernameClient}}</strong> 
                                <i class="typing-message" v-if="typingMessage == true && typingMessageChat == false "> - l'operatore sta scrivendo..</i>
                                <i class="typing-message" v-if="typingMessage == true && typingMessageChat == true "> - Kiri sta scrivendo..</i>
                        </div>
                        <div class="col-2 p-3">
                            <ficon :icon="['fa', 'sign-out-alt']" v-on:click="chiudiChat"></ficon>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="row d-block">
                <div class="col-md-12 col-xs-12 col-sm-12" id="body-chat-client">
                    <div class="content-message px-3" v-for="(value , key) in this.chat_list_message" v-bind:key="key">
                        <card-client-message :element="value" :client="client" :chatID="chatID" :userId="loginData.userId" :array_province="array_province" :array_comuni="array_comuni"></card-client-message>
                    </div>
                </div>
                
            </div>
            
            
        </div>
        <footer class="row d-block">
            <div id="send-message-client">
                <div class="col-12">
                    <input type="file" ref="inputFile" id="file-attached" style="display:none" accept="image/*" v-on:change="onFilePicked">
                    <div class="pl-1 text-left d-flex" v-if="this.showAttach == true">
                        <p>
                            {{attach}}
                            <ficon :icon="['fa', 'trash']" class="ml-1 color-icon icon-pointer" v-on:click="deleteAttach"></ficon>
                        </p>
                    </div>
                </div>
                
                <div class="col-12 mb-2 px-1">
                    <div class="input-group align-items-center">
                        <input type="text" id="input-message" ref="input-message" class="form-control" :placeholder="functionPlaceholder" v-on:blur="resetTypingMessage" v-on:keypress="typingMesage" v-on:keyup.enter="onClickSend" v-model="message" :disabled="this.endChat == true">
                        <div class="input-group-append">
                            <button class="btn" type="button" v-on:click="onClickSend" :disabled="this.endChat == true">
                                <ficon :icon="['fas', 'paper-plane']" class="color-icon"></ficon>
                            </button>
                            <button type="button" class="btn" v-on:click="attachFile" :disabled="this.endChat == true" >
                                <ficon :icon="['fas', 'paperclip']" class="color-icon"></ficon>
                            </button>
                            <audio-recorder v-if="this.fonte != 'app'"
                                    upload-url=""
                                    :show-download-button=false
                                    :show-upload-button="false"
                                    :before-recording="onBeforeRecord"
                                    :after-recording="onResultAudio"
                                    mode="minimal"
                                    :failed-upload="onResultAudio"/>
                            
                        </div>
                    </div>
                    
                </div>
            </div>
        </footer>
        <b-modal id="modal-sm" ref="modal-chiudi" size="lg" title="Chiudi Chat">
            <div class="row">
                <div class="col-12 text-center">
                    <h5>
                        Sei sicuro di voler abbandonare la chat?
                    </h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <b-button class="mt-2 mx-1" variant="outline-secondary" block @click="hideModal">Annulla</b-button>
                    <b-button class="mt-2 mx-1" variant="outline-danger" block @click="chiudiChatModal">Chiudi</b-button>
                   

                </div>
            </div>
        </b-modal>
        <b-modal id="modal-sm" ref="modal-permessi" title="Problema Rilevamento Audio">
            <div class="row">
                <div class="col-12 text-center">
                    <h6>
                        Per utilizzare le funzionalità audio assicurarsi che si disponga di un microfono e che siano concessi i permessi necessari per utilizzarlo.
                    </h6>
                                        
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">

                </div>
            </div>
        </b-modal>

        <b-modal ref="modal-request-lead" hide-footer class="modal-lg" title="Invia la richiesta di assistenza a un operatore Convergenze" @close="hideModalRequestLead">
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Nome Completo *</strong></label>
                    <input type="text" class="form-control" placeholder v-model="nominativo_request_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Numero di Telefono</strong></label>
                    <input type="text" class="form-control" placeholder v-model="telefono_request_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Indirizzo Email</strong></label>
                    <input type="text" class="form-control" placeholder v-model="email_request_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Descrivi brevemente la tua segnalazione</strong></label>
                    <textarea class="form-control" rows="3" placeholder v-model="note_request_lead" ></textarea>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <p class="font-small">Cliccando "INVIA" attesti di aver preso visione dell'Informativa della privacy e desidero essere contattato ai recapiti indicati per ricevere assistenza e informazioni sui vostri prodotti e servizi: <a href="https://convergenze.it/it/privacy-policy">Privacy Policy</a></p>
                </div>
            </div>
            <div class="row form-group" v-if="this.lead_request_error.length > 0">
                <div class="col-12">
                    <p class="text-danger"><strong>{{this.lead_request_error}}</strong></p>
                </div>
            </div>
            <div class="row">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <b-button class="mr-3" variant="outline-danger"  @click="hideModalRequestLead">Chiudi</b-button>
                    <b-button variant="outline-success"  @click="InviaRequestLead">Invia</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="modal-request-lead-ok" hide-footer title="Richiesta Inviata">
            <div class="row">
                <div class="col-12 text-center">
                    <h6>
                        Sarai contattato al più presto ai recapiti indicati.
                    </h6>                  
                </div>
            </div>
        </b-modal>
        
    </div>
</template>

<script>

import ClientChat from '../models/ClientChat'
import BackendApi from '../models/BackendApi'
import MessageChat from '../models/MessageChat'
import ChatStorage from '../models/ChatStorage'
import CardClientMessage from '@/components/CardClientMessage.vue'
import CounterNotify from '../models/CounterNotify'
import defapp from '../models/defapp'

export default {
  name: 'ClientChat',
  data: function() {
      return {
          client: null,
          usernameClient: "",
          loginData: {
              isLogged: false
          },
          isChatStart: false,
          chatID: 0,
          count_all_chat: 0,
          firstMessage: "",
          message: "",
          fonte: "",
          nominativo_request_lead: "",
          telefono_request_lead: "",
          email_request_lead: "",
          note_request_lead: "",
          lead_request_error : "",
          reparto: null,
          chat_list_message: [],
          endChat: false,
          writeMessage: false,
          typingMessage: false,
          typingMessageChat: false,
          showAttach: false,
          file: null,
          debug_files: "",
          array_province: [],
          array_comuni: [], 
          recordingAudio: false,
          requestLead: false,
          requestLeadSend: 0
      };
  },
  components: { 
      CardClientMessage   
  },
  computed: {       
    functionPlaceholder: function()
    {
        if(this.typingMessage == true && this.typingMessageChat == true)
        {
            return 'Kiri sta scrivendo ...' ;
        } 
        if(this.recordingAudio == true)
        {
            return "Stai registrando un audio .."
        }
        return 'Scrivi Messaggio'
            
    }
  },
  methods: {    
        isLogged: function() {
            if(!this.loginData) return false
            if(!this.loginData.isLogged) return false
            return true
        },
        isConnect: function() {
            if(!this.client) return false
            return this.client.isConnect
        },
        toggle () {
            this.showRecorder = false
        },
      
        onClickSend: function() {
            let type = MessageChat.TYPE_MESSAGE
            if(!this.client.isConnect) {
                this.client.open(this.loginData.queue,this.loginData.username,this.loginData.tokenAccess,this.onClientCallbackOnConnect,this.onClientCallbackReceiveMessage,this.onClientCallbackDisconnect)
            } 

            if(this.isChatStart == false)
            {
                this.isChatStart = true;
                type = MessageChat.TYPE_START_MESSAGE
            }

            if(this.chatID == 0)
            {
                let chatStorage = new ChatStorage(this.configApp)
                this.chatID = chatStorage.getChatID()
            }

            if(this.file == null)
            {

                let msg = new MessageChat()
                this.client.sendMessage(msg.prepareSendMessage(type,this.loginData.userId,this.message,"",0,defapp.TYPE_MESSAGE_RECEIVED))
                this.isChatStart = true
                this.message = ""
                this.writeMessage = false
            } else {

                let api = new BackendApi(this.configApp)
                let formData = new FormData();

                formData.append('file' , this.file)
                formData.append('type' , type)
                //formData.append('staff_id' , this.element.staff_id)
                formData.append('user_id' , this.loginData.userId)
                formData.append('message' , this.message)
                formData.append('chat_id' , this.chatID)
                formData.append('type_message' , defapp.TYPE_MESSAGE_RECEIVED)

                api.saveMessageAttach(formData, (result) => {
                    if(result.success)
                    {
                        let msg = new MessageChat()
                        this.client.sendMessage(msg.prepareSendMessage(type,this.loginData.userId,this.message,"",0,defapp.TYPE_MESSAGE_RECEIVED,"",result.message_id))
                        this.isChatStart = true
                        this.message = ""
                        this.writeMessage = false
                        this.file = null
                        this.showAttach = false
                    }
                })

            }

        },
        typingMesage:function() {
            let input = document.getElementById("input-message").value
           
            if(input.length > 2 && this.writeMessage == false)
            {
                let type = MessageChat.TYPE_TYPING_MESSAGE
                if(this.chatID == 0)
                {
                    let chatStorage = new ChatStorage(this.configApp)
                    this.chatID = chatStorage.getChatID()
                }
                let msg = new MessageChat()
                this.client.sendMessage(msg.prepareSendMessage(type,this.loginData.userId,"Sta scrivendo...","",this.chatID,defapp.TYPE_MESSAGE_RECEIVED))
                this.writeMessage = true
            } 
        },
        resetTypingMessage: function()
        {
            this.writeMessage = false
        },
        onClientCallbackOnConnect: function(isConnect) {
            console.log("onClientCallbackOnConnect -> ",isConnect)

            if(isConnect)
            {
                if (this.firstMessage != "undefined")
                {
                    console.log(localStorage.getItem("argomento"));
                    if( this.isChatStart == false)
                    {
                        let type = MessageChat.TYPE_START_MESSAGE
                        let msg = new MessageChat()
                        let fonte = "" ;
                        let argomento = null;
                        if(localStorage.getItem("fonte") != null && localStorage.getItem("fonte").length > 0)
                        {
                            fonte = localStorage.getItem("fonte")
                            localStorage.removeItem("fonte")
                        }
                        if(localStorage.getItem("argomento") != null)
                        {
                            argomento = localStorage.getItem("argomento")
                            localStorage.removeItem("argomento")
                        }
                        this.client.sendMessage(msg.prepareSendMessage(type,this.loginData.userId,this.firstMessage,"",0,defapp.TYPE_MESSAGE_RECEIVED,fonte,"",argomento))
                        localStorage.setItem("messageMotivazione" , "");
                        this.firstMessage = "";
                        this.isChatStart = true
                    }
                }

                if(this.chatID == 0)
                {
                    let chatStorage = new ChatStorage(this.configApp)
                    this.chatID = chatStorage.getChatID()
                    this.getListMessage();
                   
                }
                
            }
        },
        onClientCallbackReceiveMessage: function(message) {
            console.log("onClientCallbackReceiveMessage -> ",message)

            let result = JSON.parse(message.body)
            let counterNotify = new CounterNotify()
            
            if(result.type == "read-message")
            {
                if(result.userId != this.loginData.userId)
                {
                    counterNotify.updateClient(result,this.chat_list_message)
                }
                
            } else {

                if(result.type == "end-message")
                {
                    result.from = ""
                    this.typingMessageChat = false
                    this.endChat = true
                    this.chat_list_message.push(result)
                } else {

                    if(result.type == "typing-message")
                    {
                        this.typingMessage = true
                        this.typingMessageChat = false

                        if(result.staffname == "Chat")
                        {
                            this.typingMessageChat = true
                        }
                        //setTimeout(() => this.typingMessage = false,6000)
                    } else {

                        if(result.type == 'request-lead')
                        {
                            if(this.requestLead == false)
                            {
                                this.requestLead = true
                                this.requestLeadSend = 1
                                //this.$refs['modal-request-lead'].show()
                            }
                        }
                        else
                        {

                            this.chat_list_message.push(result)
                            this.typingMessageChat = false
                            this.typingMessage = false
                                                   
                            if(result.type == "start-message"){
                                this.getInfoChat()
                            }
                            if(result.type_user == defapp.TYPE_MESSAGE_SENT)
                            {
                                counterNotify.sendClientNotifyRead(this.client,result,this.loginData.userId)
                            }
                            this.resetTypingMessage()
                        }
                    
                    }
                }

                this.count_all_chat = this.count_all_chat + 1
                this.scrollToEnd()
            }

            

        },
        getListMessage: function()
        {
            let api = new BackendApi(this.configApp)
            api.listMessage(this.chatID,0,10, (result) => {
                if(result["success"] != false)
                {
                    this.chat_list_message = result["chat_list_message"]
                    this.count_all_chat = parseInt(result["count_all"])
                    this.scrollToEnd()
                }
            
            });

        },
        scrollToEnd : function()
        {
            let elmnt = document.getElementById('body-chat-client');
            let valueScroll = (elmnt.offsetTop + (this.count_all_chat * elmnt.offsetHeight) + elmnt.offsetHeight)
            setTimeout(() => elmnt.scrollTop = valueScroll,200);
        },
        scrollToEndPage : function()
        {
           
            setTimeout(() => window.scroll(0,1500));
        },
        chiudiChat : function()
        {
            this.$refs['modal-chiudi'].show()
            
        },
        hideModal: function()
        {
            this.$refs['modal-chiudi'].hide()
        },
        chiudiChatModal: function()
        {
            let api = new BackendApi(this.configApp)
            let chatStorage = new ChatStorage(this.configApp)
            let counterNotify = new CounterNotify()
           

            api.chiudiChat(this.chatID,this.loginData.userId, (result) => {
                if(result["success"] != false)
                {
                    counterNotify.sendNotifyChiusuraClient(this.client,chatStorage.getChatID(),this.loginData.userId)
                    chatStorage.removeChatId();
                    this.$router.push('/')
                }
            })
           
        },
        getInfoChat()
        {
            let api = new BackendApi(this.configApp)
            api.getClientChat(this.loginData.tokenAccess, (result) => {
                if (result.success == true) {
                    localStorage.setItem("chatId", result.chat_id)
                    this.chatID = result.chat_id
                } 

            });
        },
        attachFile: function() {
            document.getElementById('file-attached').click()
        },
        onFilePicked(e) {
            this.showAttach = false;
            let files = e.target.files
            let txt = e.target.files
            files.forEach(function(value) {
                txt = value.name + " " + value.size + " " + value.type + " " + value.lastModified
            })

            this.debug_files = txt
            if (files[0] !== undefined) {
                this.files = files[0];
                this.attach = files[0].name;
                this.showAttach = true;
                this.file = this.$refs.inputFile.files[0]
            }
            this.scrollToEndPage()
        },
        deleteAttach()
        {
            this.showAttach = false;
            this.attach = "";
            this.$refs.inputFile.files = null;
            this.file = null
        },
        onClientCallbackDisconnect()
        {
            setTimeout(() => {
                this.client.open(this.loginData.queue,this.loginData.username,this.loginData.tokenAccess,this.onClientCallbackOnConnect,this.onClientCallbackReceiveMessage,this.onClientCallbackDisconnect)

            },1000);
        },
        onResultAudio (data) {
            console.log('The data:', data);
            this.endChat = false;
            this.recordingAudio = false;
   
            let api = new BackendApi(this.configApp)
            let formData = new FormData();
            //const blob = new Blob([data], { type: 'audio/wav' });
            let nomefile= "recording-"+Math.floor(Date.now() / 1000)+".wav";
           
            formData.append('file' , data.blob, nomefile)
            formData.append('type' , MessageChat.TYPE_AUDIO_MESSAGE)
            formData.append('user_id' , this.loginData.userId)
            formData.append('message' , "Messaggio audio")
            formData.append('chat_id' , this.chatID)
            formData.append('type_message' , defapp.TYPE_MESSAGE_RECEIVED)

            api.saveMessageAttach(formData, (result) => {
                if(result.success)
                {
                    let type = MessageChat.TYPE_AUDIO_MESSAGE
                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessageAudio(type,this.loginData.userId,this.message,"", this.chatID,defapp.TYPE_MESSAGE_RECEIVED,"",result.message_id))
                   
                }
            })
        },
        onBeforeRecord() {
            
            this.endChat = true;
            this.recordingAudio = true;
            

        },
        InviaRequestLead()
        {   
            if(this.nominativo_request_lead.length > 0 && (this.telefono_request_lead.length > 0 || this.email_request_lead.length > 0))
            {
                let api = new BackendApi(this.configApp)
                let formData = new FormData();
                formData.append('nominativo' , this.nominativo_request_lead)
                formData.append('telefono' , this.telefono_request_lead)
                formData.append('email' , this.email_request_lead)
                formData.append('message_id' , "")
                formData.append('chat_id',this.chatID)
                formData.append('note',this.note_request_lead)

                api.generaLead(formData,(result) => {
                    if(result.success == true)
                    {
                        this.$refs['modal-request-lead'].hide();
                        this.lead_request_error = "";
                        this.nominativo_request_lead = "";
                        this.telefono_request_lead = "";
                        this.email_request_lead = "";
                        this.requestLeadSend = 2;
                        this.$refs['modal-request-lead-ok'].show();
                    }
                })

            } else {
                this.lead_request_error = "Inserire obbligatoriamente il nominativo ed almeno un contatto!";
            }
        },
        hideModalRequestLead()
        {
            this.$refs['modal-request-lead'].hide();
            this.lead_error = "";
            if(this.requestLeadSend == 0)
            {
                this.requestLeadSend = 1;
            }
        },
        ShowMoalRequestLead()
        {
            this.$refs['modal-request-lead'].show();
        }
    },
    created: function() { 
        
        //CARICO DI DEFAULT GLI ARRAY DELLE PROVINCIE E DEI COMUNI
        let api = new BackendApi(this.configApp)
        if((this.array_province.length == 0 || this.array_comuni.length == 0))
        {
            api.getProvinceComuni((res) => {
               
                this.array_province = res.result.data.province;
                this.array_comuni = res.result.data.comuni;
            })

        }        
        this.usernameClient = localStorage.getItem("usernameClient");
        //this.firstMessage = localStorage.getItem("messageMotivazione");
        this.reparto = localStorage.getItem("reparto");
        //CONTROLLO SE NEL LOCAL STORAGE E PRESENTE UN CHATID ALLORA EVITO TUTTO QUESTO E CARICO LA LISTA DEI MESSAGGI
        this.fonte = localStorage.getItem("fonte")
        if(this.usernameClient == "" )
        {
            this.$router.push('Index')
        }

        this.client = new ClientChat(this.configApp)

        

        api.autoLogin(this.usernameClient, (result) => {
            this.loginData = result
            this.isChatStart = false
            localStorage.setItem("userLogged", JSON.stringify(result));
            this.client.open(this.loginData.queue,this.loginData.username,this.loginData.tokenAccess,this.onClientCallbackOnConnect,this.onClientCallbackReceiveMessage,this.onClientCallbackDisconnect)
            
        });

        //let chatStorage = new ChatStorage(this.configApp)
        
    },
    mounted:function(){
        
    },
}

</script>